var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-inline',[_c('el-kpi',{attrs:{"margin-top":"","margin-right":"","margin-left":"","value":_vm.subscriberQuantity,"caption":"Subscribers"}}),_c('el-kpi',{attrs:{"margin-top":"","margin-right":"","value":_vm.purchaseQuantity,"caption":"Total orders"}}),_c('el-kpi',{attrs:{"margin-top":"","margin-right":"","margin-left":"","value":_vm.revenue,"unit":"kr","caption":"Total revenue"}})],1),_c('br'),_c('br'),_c('h2',[_vm._v("Orders")]),_c('bar-graph',{attrs:{"height":200,"data":_vm.monthlyRevenue,"options":{
      animation: false,
      color: ['#1181C2'],
      scales: {
        yAxes: [{
          ticks: {
            suggestedMin: 0
          },
          width: 10
        }]
      }
    }}}),_c('el-multi-switch',{attrs:{"options":[
      { value: 'week', label: 'Week' },
      { value: 'month', label: 'Month' }
    ]},model:{value:(_vm.revenuePeriod),callback:function ($$v) {_vm.revenuePeriod=$$v},expression:"revenuePeriod"}}),_c('el-multi-switch',{attrs:{"margin-top":"","options":[
      { value: 'quantity', label: 'Quantity' },
      { value: 'revenue', label: 'Revenue' }
    ]},model:{value:(_vm.revenueQuantity),callback:function ($$v) {_vm.revenueQuantity=$$v},expression:"revenueQuantity"}}),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }